import { type ReactNode } from 'react'

import type { AllStepsData } from './steps/AllStepsData'
import { FormStepContext } from './form-step-unsophisticated/context'
import { useUser } from '~/@biz_account/useUser/useUser'
import { ProgressLine } from '~/@mid_ui/progress-line/ProgressLine'
import { useUnsophisticatedTestStore } from './useUnsophisticatedTestStore'
import { BackButton } from '~/@pages_investing/project-detail/project-detail_ui/back-button/BackButton'

type Props = {
  steps: ReactNode[]
  onLeave(): void
  onCompleted(testData: AllStepsData): void
}

export function UnsophisticatedTest({ steps, onLeave, onCompleted }: Props) {
  const { user } = useUser()
  const { currentStepIndex, goBackward } = useUnsophisticatedTestStore(
    user?._id ?? null
  )

  const currentStepNumber = currentStepIndex + 1

  const handleBackClick = () => {
    if (currentStepIndex === 0) {
      onLeave()
    }

    if (currentStepIndex > 0) {
      goBackward()
    }
  }

  return (
    <div className="flex flex-col gap-10">
      <div className="flex flex-col gap-5 items-start flex-grow">
        <div className="flex justify-between items-center">
          <BackButton onClick={handleBackClick}>Späť</BackButton>
        </div>
        <ProgressLine
          valueWidth={64}
          value={`${currentStepNumber}/${steps.length}`}
          progress={(currentStepNumber / steps.length) * 100}
        />
      </div>
      <FormStepContext.Provider value={{ onCompleted }}>
        {steps[currentStepIndex]}
      </FormStepContext.Provider>
    </div>
  )
}
